
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { TestimonialsSection } from "@/sections/TestimonialsSection";
import { RequestDemoSection } from "@/sections/RequestDemoSection";
import { useInquiryForm } from "@/hooks/useInquiryForm";
import { SolutionsPageTopSection } from "@/sections/SolutionsPageTopSection";
import { UseCaseSteps } from "@/sections/UseCaseSteps";
import { CTASection } from "@/sections/CTASection";
import { CALENDLY_LINK_PRODUCT_DEMO } from "@/constants/pricing";
import { FormSourceType } from "@/containers/InquiryForm";

declare const Intercom: (...args: unknown[]) => any;

const SolutionsForAgencies = () => {
  const { t } = useTranslation();
  const { toggleInquiryForm } = useInquiryForm();

  const handleEvent = (message?: string) => {
    if (typeof Intercom !== "undefined") {
      Intercom(
        "showNewMessage",
        message ? t(`navigation:resourcesDropdown.${message}`) : undefined,
      );
    }
  };

  return (
    <>
      <Head
        pageNamespace="page/solutionsForAgencies"
        ogImage="/images/solutions-for-agencies.jpg"
      />

      <SolutionsPageTopSection
        title={t("page/solutionsForAgencies:section/video.title")}
        subtitle={t("page/solutionsForAgencies:section/video.subtitle")}
        image={{
          src: "/images/magician-with-bubbles.png",
          alt: "Magician with bubbles",
        }}
      />

      <UseCaseSteps
        title={t("page/solutionsForAgencies:section/useCases.title")}
        subtitle={t("page/solutionsForAgencies:section/useCases.subtitle")}
        steps={[
          {
            id: "STEP#1",
            image: "/images/use-case-delivery.png",
            title: t(
              "page/solutionsForAgencies:section/useCases.steps.delivery.title",
            ),
            text: t(
              "page/solutionsForAgencies:section/useCases.steps.delivery.text",
            ),
            rightSidedImage: true,
          },
          {
            id: "STEP#2",
            image: "/images/use-case-tools.png",
            title: t(
              "page/solutionsForAgencies:section/useCases.steps.tools.title",
            ),
            text: t(
              "page/solutionsForAgencies:section/useCases.steps.tools.text",
            ),
          },
          {
            id: "STEP#3",
            image: "/images/use-case-switching-tools.png",
            title: t(
              "page/solutionsForAgencies:section/useCases.steps.switching-tool.title",
            ),
            text: t(
              "page/solutionsForAgencies:section/useCases.steps.switching-tool.text",
            ),
            rightSidedImage: true,
          },
        ]}
      />
      <CTASection
        title={t("page/solutionsForAgencies:section/cta.title")}
        buttonLabel={t("common:contactUs")}
        onButtonClick={() => handleEvent("contactUs")}
        wrapperBgColor="rgba(97, 121, 255, 0.1)"
      />
      <UseCaseSteps
        title={t("page/solutionsForAgencies:section/solutions.title")}
        subtitle={t("page/solutionsForAgencies:section/solutions.subtitle")}
        steps={[
          {
            id: "STEP#1",
            image: "/images/solutions-convert.png",
            title: t(
              "page/solutionsForAgencies:section/solutions.steps.convert.title",
            ),
            text: t(
              "page/solutionsForAgencies:section/solutions.steps.convert.text",
            ),
            button: {
              label: t("common:learnMore"),
              href: "/",
            },
            rightSidedImage: true,
            imageStyles: {
              maxWidth: 400,
            },
          },
          {
            id: "STEP#2",
            image: "/images/solutions-backup.png",
            title: t(
              "page/solutionsForAgencies:section/solutions.steps.backup.title",
            ),
            text: t(
              "page/solutionsForAgencies:section/solutions.steps.backup.text",
            ),
            button: {
              label: t("common:learnMore"),
              href: "/figma-design-backup",
            },
            imageStyles: {
              maxWidth: 400,
            },
          },
          {
            id: "STEP#3",
            image: "/images/solutions-launch.png",
            title: t(
              "page/solutionsForAgencies:section/solutions.steps.launch.title",
            ),
            text: t(
              "page/solutionsForAgencies:section/solutions.steps.launch.text",
            ),
            button: {
              label: t("common:learnMore"),
              href: "https://builder.magicul.io/",
            },
            rightSidedImage: true,
          },
        ]}
      />
      <TrustedBySection />
      <TestimonialsSection />

      <RequestDemoSection
        title={t("section/requestDemo:title")}
        subtitle={t("section/requestDemo:subtitle")}
        buttonLabel={t("section/requestDemo:buttonLabel")}
        wrapperBgColor="#F7F8FD"
        onButtonClick={() =>
          toggleInquiryForm(FormSourceType.FOR_AGENCIES_INQUIRY)
        }
        requestDemoLink={CALENDLY_LINK_PRODUCT_DEMO}
      />
    </>
  );
};

export default SolutionsForAgencies;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/solutions/for-agencies',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  